import React from "react";
import { BadgeCheck } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

// Marks accounts seeded for internal testing (see backend seed_test_accounts.py)
// so nobody mistakes a QA account for a real paying customer in the UI.
export default function DevAccountBadge() {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0"
                        data-testid="dev-account-badge"
                    >
                        <BadgeCheck size={13} strokeWidth={2.5} />
                    </span>
                </TooltipTrigger>
                <TooltipContent data-testid="dev-account-badge-tooltip">Developer</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
